import {WhatsApp} from "@mui/icons-material";

export default function BackendUnavailable() {
    return (
        <div
            style={{
                position: "relative",
                height: "100vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(180deg, #F5FBF9 0%, #FFFFFF 100%)",
            }}
        >
            <div
                className="p-4 text-center shadow-lg"
                style={{
                    background: "linear-gradient(180deg, #F5FBF9 0%, #FFFFFF 100%)",
                    borderRadius: 16,
                    border: "1px solid #E6F0EC",
                    maxWidth: 480,
                    margin: "0 auto",
                }}
            >
                <p
                    className="fw-bold"
                    style={{
                        fontSize: "1.5rem",
                        lineHeight: 1.4,
                        textAlign: "center",
                        marginBottom: "0.75rem",
                        color: "#0A564B",
                    }}
                >
                    Service Temporarily Unavailable
                </p>

                <p
                    id="lockedContentBody"
                    style={{
                        fontSize: "0.95rem",
                        textAlign: "center",
                        marginBottom: "1.5rem",
                        color: "#111827",
                    }}
                >
                    We’re having trouble reaching the server. Please try again later or{" "}
                    contact us for assistance.
                </p>

                <a
                    href="https://wa.me/6282228886906?text=Hello%20Trucarbon,%20I%20need%20help%20accessing%20the%20app"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold shadow-sm"
                    style={{
                        borderRadius: "12px",
                        backgroundColor: "#25D366",
                        color: "#fff",
                        textDecoration: "none",
                    }}
                >
                    <WhatsApp />
                    Contact Us via WhatsApp
                </a>
            </div>
        </div>
    );
}
